/**
 * Refresh Indicator Component
 *
 * Shows last updated time and refresh button.
 */

import { ArrowPathIcon } from '@heroicons/react/24/outline';

export default function RefreshIndicator({
  lastUpdated,
  onRefresh,
  loading = false,
}) {
  const formatTime = (timestamp) => {
    if (!timestamp) return 'Never';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="flex items-center gap-3 text-sm text-gray-500">
      <span>Last updated: {formatTime(lastUpdated)}</span>
      <button
        onClick={onRefresh}
        disabled={loading}
        className={`p-1.5 rounded-lg hover:bg-gray-100 transition-colors ${
          loading ? 'cursor-not-allowed opacity-50' : ''
        }`}
        title="Refresh data"
      >
        <ArrowPathIcon
          className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`}
        />
      </button>
    </div>
  );
}
